/**
 * Parse HTML entities
 * @param str String to parse
 * @returns Parsed string
 *
 * @example
 * ```ts
 * const parsed = parseHtmlEntities('Hello, it&#39;s me, &#72;&#101;&#108;&#108;&#111;&#33;');
 * console.log(parsed); // Hello, it's me, Hello!
 * ```
 */
export const parseHtmlEntities = (str: string) => {
	return str.replace(/&#([0-9]{1,3});/gi, function (match, numStr) {
		const num = parseInt(numStr, 10); // read num as normal number
		return String.fromCharCode(num);
	});
};
